import PropTypes from 'prop-types';
import React from 'react';

const MessageButton = ({ onClick, children }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onClick();
    }
  };
  return <span tabIndex="0" role="button" onKeyPress={handleKeyPress} onClick={onClick}>{children}</span>;
};

MessageButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default MessageButton;
